import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DefaultDialog from "../DefaultDialog";
import { useState } from "react";

interface DialogWithTriggerProps {
  title?: string;
  description?: string;
}
export default function DialogWithTrigger({
  title,
  description,
}: DialogWithTriggerProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant="text"
        onClick={() => setIsOpen(true)}
        size="small"
        sx={{
          alignSelf: "flex-start",
        }}
      >
        {title}
      </Button>
      <DefaultDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
        actionButtons={
          <Button size="small" onClick={() => setIsOpen(false)}>
            {t("common.close")}
          </Button>
        }
      >
        <Typography align="center">{description}</Typography>
      </DefaultDialog>
    </>
  );
}
